import { Icon, IconSize, IconVariants } from "@next-platform/client-common-spicy-ui";
import React from "react";

type GradientCardProps = {
  icon: IconVariants;
  title: string;
  description: string;
};

const GradientCard = ({ icon, title, description }: GradientCardProps): React.ReactElement => (
  <div className="w-[400px] h-[350px] max-h-[auto] border border-solid border-[rgba(255,114,245,0.2)] dark:border-[rgba(0,114,245,0.4)] bg-gradient-to-b from-[#001b3a59] dark:from-[#001b3a] to-[#2210353f] dark:to-[#221035] from-[-20%] to-100% rounded-3xl flex flex-col items-center gap-8">
    <div className="mt-8">
      <Icon icon={icon} size={IconSize.XLARGE} />
    </div>
    <h2 className="text-2xl max-w-[80%] text-center">{title}</h2>
    <p className="text-lg max-w-[90%] mb-8 text-center">{description}</p>
  </div>
);

export default GradientCard;
